import React from 'react'

import ShakingHandsIcon from 'components/Luxkit/Icons/custom/ShakingHandsIcon'
import DoubleHearts from 'components/Luxkit/Icons/custom/DoubleHeartsIcon'
import ExecuteBrilliantly from 'components/Luxkit/Icons/custom/ExecuteBrilliantlyIcon'
import TwoPeopleTalking from 'components/Luxkit/Icons/custom/TwoPeopleTalkingIcon'

const missionAndValuesItems = [
  {
    title: 'Make People Love Us',
    text: [
      "We don't just want our customers to like us, we want them to love us",
      'We will never settle — we will go above and beyond to exceed expectations — every time',
      'We care — we pride ourselves on our relationships. With members, with our clients, with our team',
      'Always be helping',
    ],
    icon: <DoubleHearts size={68} colour="primary" />,
  },
  {
    title: 'Move Fast & Find the Solution',
    text: [
      "Take responsibility. Be prepared to get it wrong some of the time (you won't be blamed for having a go.)",
      'We reward speed and efficiency — We must never dwell on mistakes (but we MUST learn from them)',
      'Back yourself in — give things a try and improve processes',
      'Challenge the status quo',
    ],
    icon: <TwoPeopleTalking size={68} colour="primary" />,
  },
  {
    title: "Do What's Right",
    text: [
      'No Hierarchy. Everyone’s door should always be open',
      "Pay it forward. It won't be forgotten",
      'Feedback is a gift (but deliver it the right way)',
      'Never, ever, ever, screw a customer',
    ],
    icon: <ShakingHandsIcon size={68} colour="primary" />,
  },
  {
    title: 'Execute Brilliantly',
    text: [
      'Our customers care about the details, so should we',
      'Try to think about every possible problem and solve them',
      'Never ignore the details',
      'Get stuff done, properly',
    ],
    icon: <ExecuteBrilliantly size={68} colour="primary" />,
  },
]

export default missionAndValuesItems
